import api from "@/api";

export default {
  // GET: Lấy lịch sử chat (phân trang)
  getHistory(congTrinhId, params = {}) {
    return api.get(`/api/cong-trinh/${congTrinhId}/chat`, { params });
  },

  // POST: Gửi tin nhắn
  sendMessage(congTrinhId, userId, payload) {
    return api.post(`/api/cong-trinh/${congTrinhId}/chat/send`, payload, {
      params: { userId }
    });
  },

  // PATCH: Ghim / Bỏ ghim tin nhắn
  togglePin(msgId) {
    return api.patch(`/api/cong-trinh/message/${msgId}/chat/pin`);
  },

  // GET: Lấy danh sách tin đã ghim
  getPinned(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/chat/pinned`);
  },

  // POST: Đánh dấu đã đọc (để xóa badge đỏ)
  markRead(congTrinhId, userId) {
    return api.post(`/api/cong-trinh/${congTrinhId}/chat/read`, null, {
      params: { userId }
    });
  },

  // GET: Đếm số tin chưa đọc
  getUnreadCount(congTrinhId, userId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/chat/unread`, {
      params: { userId }
    });
  },

  getSince(congTrinhId, after, afterId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/chat/since`, {
      params: { after, afterId },
    });
  },
};